import { render, staticRenderFns } from "./SimpleQuote.vue?vue&type=template&id=4a52b7ff"
import script from "./SimpleQuote.vue?vue&type=script&lang=js"
export * from "./SimpleQuote.vue?vue&type=script&lang=js"
import style0 from "./SimpleQuote.vue?vue&type=style&index=0&id=4a52b7ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports